<template>
  <div class="sm-login">
    <!-- 设置密码-->
    <div class="title mb-8 tc">{{$t('login.setpassword')}}</div>
    <el-form ref="setPasswordRef" :rules="rules" :model="formPwd" label-position="top" @keyup.enter.native="submitPwd">
      <!-- 密码-->
      <el-form-item :label="$t('login.password')" prop="password">
        <passwordInput v-model.trim="formPwd.password" :placeholder="$t('login.password')"/>
      </el-form-item>
      <!-- 确认密码-->
      <el-form-item :label="$t('login.confirmpassword')" prop="agapassword">
        <passwordInput v-model.trim="formPwd.agapassword" :placeholder="$t('login.agapassword')"/>
      </el-form-item>
      <!-- 登录-->
      <el-form-item>
        <el-button type="primary" @click="submitPwd">{{$t('login.login')}}</el-button>
      </el-form-item>
    </el-form>
<!--    <el-divider content-position="center">或使用您的邮箱</el-divider>-->
<!--    <div class="login-link">-->
<!--      <img src="@/assets/img/login/Group1000005888@2x.webp">-->
<!--      <img src="@/assets/img/login/GroupS1000005852@2x.webp">-->
<!--      <img src="@/assets/img/login/GroupS1000005853@2x.webp">-->
<!--    </div>-->
<!--    <div class="login-confirm">-->
<!--      <div class="login-confirm-box">继续，即表示您同意我们的 <span class="green-text-2 cursor-pointer" @click="goPage('helpdetail',{id:9})">条款和条件</span> 并确认-->
<!--        您已阅读我们的 <span class="green-text-2 cursor-pointer" @click="goPage('helpdetail',{id:11})">隐私政策</span>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import passwordInput from "@/components/passwordInput";
import {
  isPassword
} from "@/util/validate";
import {
  isEmpty
} from "@/util/util";

import {
  MessageError,
  startLoading
} from "@/util/util"
import {
  logoutToken,
  updatePwd
} from "@/request/requests";
export default {
  name: "setPassword",
  props:{
    email:String,
    code:String
  },
  components: {
    passwordInput
  },
  data() {
    let validatePswLen = (rule, value, callback) => {
      if (!isPassword(value)) {
        callback(new Error(this.$t("login.validatepswlen")));
      } else {
        callback();
      }
    };
    let validatePwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t("login.passwordagain")));
      } else if (value !== this.formPwd.password) {
        callback(new Error(this.$t("login.validatepswlen")));
      } else {
        callback();
      }
    };
    return {
      screenWidth: null,
      formPwd: {
        password: '',
        agapassword:''
      },
      rules: {
        password: [
          {
            required: true,
            message: this.$t('home.pleaseenter') + ' ' + this.$t('login.password'),
            trigger: 'blur'
          },
          {
            validator: validatePswLen,
            trigger: 'blur'
          },
        ],
        agapassword: [
          {
            required: true,
            message: this.$t('login.passwordagain'),
            trigger: 'blur'
          },
          {
            validator: validatePwd,
            trigger: 'blur'
          }
        ],
      }

    }
  },
  methods: {
    async submitPwd() {
      this.$refs['setPasswordRef'].validate((valid) => {
        if (!valid) return;
        this.toUpdatePwd();
      })
    },
    async toUpdatePwd(){
      let loading = startLoading()
      let params = {
        ...this.formPwd,
        email: this.email,
        code: this.code,
        client: 'mob'
      };
      let res = await updatePwd(params)
      if (res.status == "200") {
        loading.close()
        this.$notification.success({
          message: "Login successful",
          description: `Welcome back，${this.email}`
        });
        if (this.screenWidth > 576.98) {
          this.goPage('home');
        } else {
          this.goPage('phonehome');
        }
      } else {
        await logoutToken();
        this.$cookies.remove('token');
        this.$cookies.remove('userInfo');
        this.$cookies.remove('deadline');
        loading.close()
        MessageError(res.msg)
      }
    },
    goPage(page, params) {
      if (!isEmpty(params)) {
        this.$router.push({
          name: page,
          query: params
        })
        return
      }
      this.$router.push({
        name: page
      })
    },
    calcWidth() {
      this.screenWidth = window.screen.width;
      this.$forceUpdate();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/login.scss";
.login-confirm{
  font-family: Poppins, Poppins;
  font-weight: 700;
  font-size: 16px;
  color: #98A2B3;
  line-height: 25px;
  text-align: center;
  &-box{
    width: 76%;
    margin: 0 auto;
  }
  @media (max-width:576.98px) {
    font-size: 12px;
    padding-bottom: 67px;
  }
}

@media(max-width: 576.98px) {
  .login-link {
    padding: 0 calc(76px - 24px);

    img {
      cursor: pointer;
      width: 48px;

      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }

  .el-form-item {
    margin-bottom: 45px;
  }

  ::v-deep .el-divider__text {
    font-size: 14px !important;
  }

  ::v-deep .el-divider--horizontal {
    width: 86% !important;
  }
}

</style>